document.addEventListener('DOMContentLoaded', function() {

    // ==========================================
    // Mobile Drawer Toggle Logic
    // Handles opening and closing of the mobile navigation drawer
    // ==========================================
    const mobileToggle = document.getElementById('smcr-mobile-toggle');
    const mobileDrawer = document.getElementById('smcr-mobile-drawer');
    const drawerClose = document.getElementById('smcr-drawer-close');
    const drawerOverlay = document.getElementById('smcr-drawer-overlay');

    if(mobileToggle && mobileDrawer) {
        mobileToggle.addEventListener('click', function() {
            mobileDrawer.classList.add('open');
            drawerOverlay.classList.add('open');
        });

        drawerClose.addEventListener('click', function() {
            mobileDrawer.classList.remove('open');
            drawerOverlay.classList.remove('open');
        });

        drawerOverlay.addEventListener('click', function() {
            mobileDrawer.classList.remove('open');
            drawerOverlay.classList.remove('open');
        });
    }

    // ==========================================
    // Categories Dropdown Logic
    // Handles hover states for the "All Categories" button
    // ==========================================
    const categoriesBtn = document.getElementById('smcr-categories-btn');
    const categoriesDropdown = document.getElementById('smcr-categories-dropdown');
    let timeout;

    if(categoriesBtn && categoriesDropdown) {
        categoriesBtn.addEventListener('mouseenter', function() {
            clearTimeout(timeout);
            
            // Calculate precise position directly beneath the button
            let btnRect = categoriesBtn.getBoundingClientRect();
            let wrapper = document.querySelector('.smcr-header-wrapper');
            let wrapperRect = wrapper ? wrapper.getBoundingClientRect() : {top: 0, left: 0};
            
            // categoriesDropdown.style.top = (btnRect.bottom - wrapperRect.top + 8) + 'px'; // +15 for padding spacing
            categoriesDropdown.style.left = (btnRect.left - wrapperRect.left) + 'px';
            categoriesDropdown.style.display = 'flex';
        });
        
        categoriesBtn.addEventListener('mouseleave', function() {
            timeout = setTimeout(function() {
                categoriesDropdown.style.display = 'none';
            }, 200);
        });

        categoriesDropdown.addEventListener('mouseenter', function() {
            clearTimeout(timeout);
        });

        categoriesDropdown.addEventListener('mouseleave', function() {
            timeout = setTimeout(function() {
                categoriesDropdown.style.display = 'none';
            }, 200);
        });
    }

    // ==========================================
    // Predictive AJAX Search Logic
    // Fetches live product suggestions from Shopify's Search API
    // ==========================================
    const searchInput = document.getElementById('smcr-search-input');
    const searchResults = document.getElementById('smcr-predictive-search-results');
    let searchTimeout;

    if(searchInput && searchResults) {
        searchInput.addEventListener('input', function() {
            clearTimeout(searchTimeout);
            const query = this.value.trim();

            if (query.length > 1) {
                searchTimeout = setTimeout(function() {
                    fetch(`/search/suggest.json?q=${query}&resources[type]=product&resources[limit]=4`)
                        .then(response => response.json())
                        .then(data => {
                            const products = data.resources.results.products;
                            
                            if (products.length > 0) {
                                searchResults.innerHTML = '';
                                products.forEach(product => {
                                    const item = document.createElement('a');
                                    item.href = product.url;
                                    item.classList.add('smcr-predictive-item', 'smcr_body_fnt', 'smcr_body_text_type3', 'smcr_txt_black');
                                    
                                    const img = document.createElement('img');
                                    img.src = product.image;
                                    img.alt = product.title;
                                    
                                    const title = document.createElement('span');
                                    title.textContent = product.title;
                                    
                                    item.appendChild(img);
                                    item.appendChild(title);
                                    searchResults.appendChild(item);
                                });
                                searchResults.style.display = 'block';
                            } else {
                                searchResults.innerHTML = '<div style="padding: 15px;" class="smcr_body_fnt smcr_body_text_type3">No results found for "'+query+'"</div>';
                                searchResults.style.display = 'block';
                            }
                        });
                }, 300); // Debounce delay
            } else {
                searchResults.style.display = 'none';
                searchResults.innerHTML = '';
            }
        });

        // Hide search results when clicking outside
        document.addEventListener('click', function(e) {
            if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
                searchResults.style.display = 'none';
            }
        });
        
        // Show again when clicking input if there's value
        searchInput.addEventListener('focus', function() {
            if (this.value.trim().length > 2 && searchResults.innerHTML !== '') {
                searchResults.style.display = 'block';
            }
        });
    }

    // ==========================================
    // Smart Sticky Header Logic
    // Sticks the header to the top and hides the bottom row when scrolling down
    // ==========================================
    const headerWrapper = document.querySelector('.smcr-header-wrapper');
    const header = document.getElementById('smcr-header');
    let lastScrollY = window.scrollY;

    if (headerWrapper && header) {
        // Set wrapper height so the page doesn't jump when header becomes fixed
        setTimeout(function() {
            headerWrapper.style.minHeight = header.offsetHeight + 'px';
        }, 100);

        // Listen specifically to window and the theme's .page-wrapper container (no capture phase)
        const scrollHandler = function() {
            let pageWrapper = document.querySelector('.page-wrapper');
            let currentScrollY = window.scrollY || document.documentElement.scrollTop;
            
            // If the theme is using .page-wrapper for scrolling (desktop), grab its scrollTop
            if (pageWrapper && pageWrapper.scrollTop > 0) {
                currentScrollY = Math.max(currentScrollY, pageWrapper.scrollTop);
            }
            
            // Stick to top if scrolled past 50px
            if (currentScrollY > 50) {
                headerWrapper.classList.add('is-fixed');
                
                // Only change state if we scrolled more than 10px vertically (prevents horizontal trackpad jitter)
                if (Math.abs(currentScrollY - lastScrollY) > 10) {
                    // Hide bottom row if scrolling DOWN
                    if (currentScrollY > 100 && currentScrollY > lastScrollY) {
                        headerWrapper.classList.add('scrolled-down');
                    } 
                    // Show bottom row if scrolling UP
                    else if (currentScrollY < lastScrollY) {
                        headerWrapper.classList.remove('scrolled-down');
                    }
                    lastScrollY = currentScrollY;
                }
            } else {
                // At the top of the page, unstick everything
                headerWrapper.classList.remove('is-fixed');
                headerWrapper.classList.remove('scrolled-down');
                lastScrollY = currentScrollY;
            }
        };

        window.addEventListener('scroll', scrollHandler, { passive: true });
        
        let wrapperNode = document.querySelector('.page-wrapper');
        if (wrapperNode) {
            wrapperNode.addEventListener('scroll', scrollHandler, { passive: true });
        }
    }
});


// smcr-animations.js
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15 // Triggers when 15% of the element is visible
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('smcr_animate_visible');
        observer.unobserve(entry.target); // Stop observing once animated
      }
    });
  }, observerOptions);

  // Target all elements you want to animate
  const animateElements = document.querySelectorAll('.smcr_animate_up, .smcr_animate_fade');
  animateElements.forEach(el => observer.observe(el));
});

/* ============================================================================
  AJAX Add to Cart for SMCR Product Cards
============================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const ajaxCartForms = document.querySelectorAll('.smcr_add_to_cart_form');
  
  ajaxCartForms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent.trim();
      const originalBg = submitBtn.style.backgroundColor;
      const originalColor = submitBtn.style.color;
      
      // Update button state to Adding
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
      
      const formData = new FormData(form);
      
      // Get all cart-items-component sections so they can be updated
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let sectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
      });
      // Ensure cart-drawer-section is included if drawer is active
      if (document.querySelector('cart-drawer') && !sectionIds.includes('cart-drawer-section')) {
        sectionIds.push('cart-drawer-section');
      }
      if (sectionIds.length > 0) {
        formData.append('sections', sectionIds.join(','));
      }
      
      try {
        const addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) 
                       ? window.Shopify.routes.root + 'cart/add.js' 
                       : '/cart/add.js';

        const response = await fetch(addUrl, {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        const responseJSON = await response.json();
        
        // Update all requested sections directly in the DOM (e.g., cart drawer)
        if (responseJSON.sections) {
          Object.keys(responseJSON.sections).forEach((sectionId) => {
            const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
            if (sectionElement) {
              sectionElement.innerHTML = responseJSON.sections[sectionId];
            }
          });
        }
        
        // Fetch cart to get updated count for the bubble
        const cartResponse = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js');
        const cart = await cartResponse.json();
        
        // 1. Manually update cart bubble just in case event fails to trigger
        const cartBubbleCount = document.querySelector('.cart-bubble__text-count');
        const cartBubble = document.querySelector('.cart-bubble');
        const cartIcon = document.querySelector('cart-icon');
        
        if (cartBubbleCount) {
          cartBubbleCount.textContent = cart.item_count < 100 ? cart.item_count : '';
          cartBubbleCount.classList.remove('hidden');
        }
        if (cartBubble) {
          cartBubble.classList.remove('visually-hidden');
        }
        if (cartIcon) {
          cartIcon.classList.add('header-actions__cart-icon--has-cart');
          // Theme's cart-icon.js relies on this session storage value
          sessionStorage.setItem('cart-count', JSON.stringify({ value: String(cart.item_count), timestamp: Date.now() }));
        }
        
        // 2. Dispatch the standard events for theme compatibility
        // Using standard DOM event strings that Shopify often expects
        const eventDetail = {
          cart: { totalQuantity: cart.item_count },
          detail: { sections: responseJSON.sections }
        };
        
        ['cartLinesUpdate', 'cart:lines:update', 'cart_lines_update'].forEach(eventName => {
          const cartUpdateEvent = new CustomEvent(eventName, { bubbles: true, detail: { itemCount: cart.item_count } });
          cartUpdateEvent.promise = Promise.resolve(eventDetail);
          document.dispatchEvent(cartUpdateEvent);
        });
        
        // Update button state to Added
        submitBtn.textContent = 'Added';
        
        // Revert back after 2 seconds
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        submitBtn.textContent = 'Error';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });
});

/* ============================================================================
  SMCR Price Filter Web Component
============================================================================== */
if (!customElements.get('smcr-price-slider')) {
  customElements.define('smcr-price-slider', class extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        this.idPrefix = this.dataset.idPrefix;
        this.filterLabel = this.dataset.filterLabel;
        
        this.minRange = this.querySelector('.smcr-price-range-min');
        this.maxRange = this.querySelector('.smcr-price-range-max');
        this.progress = this.querySelector('.smcr-price-slider-progress');
        this.labelMin = this.querySelector('.smcr-price-label-min');
        this.labelMax = this.querySelector('.smcr-price-label-max');
        
        this.minInput = document.getElementById(this.filterLabel + '-GTE-' + this.idPrefix);
        this.maxInput = document.getElementById(this.filterLabel + '-LTE-' + this.idPrefix);
        
        if(!this.minRange || !this.maxRange || !this.progress) {
          return; // Essential visual elements missing
        }

        // Force the max property from the raw HTML attribute to prevent clamping
        this.maxLimit = parseFloat(this.minRange.getAttribute('max')) || 100;
        this.minRange.max = this.maxLimit;
        this.maxRange.max = this.maxLimit;

        // NOW safely force the values to override any browser innerHTML race conditions
        this.minRange.value = this.minRange.dataset.initialValue;
        this.maxRange.value = this.maxRange.dataset.initialValue;

        this.currencySymbol = this.dataset.currencySymbol || '$';

        this.updateProgress = this.updateProgress.bind(this);
        this.triggerUpdate = this.triggerUpdate.bind(this);

        this.minRange.addEventListener('input', () => {
          if(parseFloat(this.minRange.value) > parseFloat(this.maxRange.value)) {
            this.minRange.value = this.maxRange.value;
          }
          this.updateProgress();
        });

        this.maxRange.addEventListener('input', () => {
          if(parseFloat(this.maxRange.value) < parseFloat(this.minRange.value)) {
            this.maxRange.value = this.minRange.value;
          }
          this.updateProgress();
        });

        this.minRange.addEventListener('change', this.triggerUpdate);
        this.maxRange.addEventListener('change', this.triggerUpdate);

        // Safe, bounded visual sync to defeat any DOM morphing or layout race conditions
        this.updateProgress();
        let syncCount = 0;
        const syncInterval = setInterval(() => {
          this.updateProgress();
          syncCount++;
          if (syncCount > 20) clearInterval(syncInterval);
        }, 100);

        // Ultimate DOM Morphing Defeater
        // If morphdom strips the inline style from the live element during an AJAX update, put it right back.
        const styleObserver = new MutationObserver((mutations) => {
          if (!this.progress.style.width || this.progress.style.width === '') {
            this.updateProgress();
          }
        });
        styleObserver.observe(this.progress, { attributes: true, attributeFilter: ['style'] });
      }, 0);
    }

    updateProgress() {
       var minVal = parseFloat(this.minRange.value);
       if (isNaN(minVal)) minVal = parseFloat(this.minRange.dataset.initialValue) || 0;
       
       var maxVal = parseFloat(this.maxRange.value);
       if (isNaN(maxVal)) maxVal = parseFloat(this.maxRange.dataset.initialValue) || this.maxLimit;
       
       var maxLim = this.maxLimit > 0 ? this.maxLimit : 100;
       
       var percentMin = (minVal / maxLim) * 100;
       var percentMax = (maxVal / maxLim) * 100;
       
       if (percentMin < 0) percentMin = 0;
       if (percentMax > 100) percentMax = 100;
       
       // Explicitly calculate width to ensure it renders correctly across all browsers
       var width = percentMax - percentMin;
       if (width < 0) width = 0;
       
       this.progress.style.left = percentMin + '%';
       this.progress.style.width = width + '%';
       this.progress.style.right = 'auto'; // Reset right in case it was set
       
       if (this.labelMin) this.labelMin.textContent = this.currencySymbol + Math.round(minVal);
       if (this.labelMax) this.labelMax.textContent = this.currencySymbol + Math.round(maxVal) + (maxVal >= maxLim ? '+' : '');
    }

    triggerUpdate(e) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      if (this.minInput && this.maxInput) {
        this.minInput.value = this.minRange.value;
        this.maxInput.value = this.maxRange.value;
        this.minInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

/* ============================================================================
  Global AJAX MutationObserver for 3rd Party Apps (Wishlist Hero)
============================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  let wishlistTimeout;
  
  const triggerWishlistHero = () => {
    clearTimeout(wishlistTimeout);
    wishlistTimeout = setTimeout(() => {
      const buttons = document.querySelectorAll('.wishlist-hero-custom-button');
      if (buttons.length > 0) {
         // Deep wipe to defeat morphdom reusing nodes with attached JS state
         buttons.forEach(btn => {
             // Clone the node to destroy any hidden state/listeners, forcing WishlistHero to re-init it
             const clone = btn.cloneNode(true);
             // Ensure the clone doesn't retain any "initialized" classes that morphdom might have missed
             clone.classList.remove('wlh-loaded', 'wishlisthero-loaded');
             btn.parentNode.replaceChild(clone, btn);
         });

         const events = ['wishlist-hero-update', 'wlh-update', 'wishlisthero-reload', 'wishlist-hero-reload'];
         events.forEach(e => {
            document.dispatchEvent(new CustomEvent(e));
            document.dispatchEvent(new Event(e));
            window.dispatchEvent(new CustomEvent(e));
            window.dispatchEvent(new Event(e));
         });
         
         if (window.WishlistHero) {
           try { window.WishlistHero.reload(); } catch(e){}
           try { window.WishlistHero.init(); } catch(e){}
         }
         if (window.WishlistHeroApp) {
           try { window.WishlistHeroApp.reload(); } catch(e){}
           try { window.WishlistHeroApp.init(); } catch(e){}
         }
      }
    }, 500); // Wait 500ms for DOM to settle completely
  };

  // 1. Listen for Shopify's standard facet update event
  document.addEventListener('collectionUpdate', triggerWishlistHero);
});

